import { MapConfiguration } from "@3ddv/ngx-sites-builder-lib";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AsyncSubject, Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class VersionService{
    private apiRoot = '/api/tools';
    private config: MapConfiguration;
    private config$: Subject<MapConfiguration> = new Subject();
    private asyncSidebar$: AsyncSubject<any> = new AsyncSubject();
    private version$: Subject<string> = new Subject();

    constructor(private http: HttpClient){}

    public getMinisiteConfigAsync$(): Observable<MapConfiguration>{
        return this.asyncSidebar$.asObservable();
    }
    
    public setMinisiteConfigAsync$(mapConfig: MapConfiguration): void{
        this.config = mapConfig;
        this.asyncSidebar$.next(mapConfig);
        this.asyncSidebar$.complete();
    }
    
    public getPanoVersion$(): Observable<string>{
        return this.version$.asObservable();
    }
    public setPanoVersion(version: string): void{
        this.config.set_id = version;
        return this.version$.next(this.config.set_id);
    }
}